module.exports = __webpack_public_path__ + "img/太陽.f4636f32.svg";